import React from 'react';
import { connect } from 'react-redux'
import Cookies from 'react-cookies'
import 'antd/dist/antd.min.css';
import { Result } from 'antd';
import { withTranslation } from "react-i18next";
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Login from 'components/Login';
import Main from 'components/Main';
import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common'

class App extends React.Component {

	componentDidMount(){
		this.props.setBasename()
		this.props.fetchCheckIP()
	}

	render(){
		const {t, remoteAddr, checkIP } = this.props;
		const favicon = t('favicon')

		const Forbidden = () => (
			<Result
				status="403"
				title="403"
				subTitle={`Sorry, ${remoteAddr} IP is not authorized to access this page.`}
			/>
		)

		if(checkIP==null) return <div/>
		if(this.props.checkIP) {
			return (
				<HelmetProvider>
					<Helmet>
						<link rel="icon" href={favicon} />
					</Helmet>
					{isEmpty(Cookies.load("se_session")) ? <Login/> : <Main/>}
				</HelmetProvider>
			)
		 } else {
			return (
				<HelmetProvider>
					<Helmet>
						<link rel="icon" href={favicon} />
					</Helmet>
					<Forbidden/>
				</HelmetProvider>
			)
		 }
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		checkIP: reducers.login.checkIP,
		remoteAddr: reducers.login.remoteAddr
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setBasename: () => { dispatch({type: types.SET_BASENAME})},
		fetchCheckIP: () => { dispatch({type: types.FETCH_CHECKIP_REQUEST})},
	}
}

export default withTranslation()(connect(mapStateToProps,mapDispatchToProps)(App))